import Table from 'shared/components/tables/components/Table';
import TableHeader from 'shared/components/tables/components/TableHeader';
import TableFooter from 'shared/components/tables/components/TableFooter';
import ActionLinks from 'shared/components/tables/components/ActionLinks';
import EmployeeLink from 'shared/components/tables/components/EmployeeLink';
import {
  InteractiveAccordionTable,
  InteractiveTable,
  InteractiveContext,
  Pagination,
  SearchBox,
  DropdownFilter,
  FancyFilter,
  FancyFilterPills,
  ScopeFilter
} from 'shared/components/tables/interactive';
import {
  TableRowWithAvatar
} from 'shared/components/tables/components/rows';

Table.Header = TableHeader;
Table.Footer = TableFooter;
Table.RowWithAvatar = TableRowWithAvatar;

export {
  Table,
  InteractiveAccordionTable,
  InteractiveTable,
  InteractiveContext,
  Pagination,
  SearchBox,
  DropdownFilter,
  FancyFilter,
  FancyFilterPills,
  ActionLinks,
  EmployeeLink,
  ScopeFilter
};
